import {css} from 'lit';

export default css`

.heading {
  margin: 0.75em 0 0.25em;
  padding: 0;
  color: var(--forced-contrast-heading-primary, #022851);
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.2;
}
:where(:not([class*=block-field-])) > .heading:first-child {
  margin-top: 0;
}

.heading--primary {
  margin: 0.75em 0 0.25em;
  padding: 0;
  color: var(--forced-contrast-heading-primary, #022851);
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.2;
  color: var(--forced-contrast-heading-primary, #13639e);
  font-size: 1.6055rem;
}
:where(:not([class*=block-field-])) > .heading--primary:first-child {
  margin-top: 0;
}
@media (min-width: 768px) {
  .heading--primary {
    font-size: 2.0995rem;
  }
}

.heading--secondary {
  margin: 0.75em 0 0.25em;
  padding: 0;
  color: var(--forced-contrast-heading-primary, #022851);
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.2;
  color: var(--forced-contrast-heading-secondary, #666);
  font-size: 1.3325rem;
}
:where(:not([class*=block-field-])) > .heading--secondary:first-child {
  margin-top: 0;
}
@media (min-width: 768px) {
  .heading--secondary {
    font-size: 1.7425rem;
  }
}

.heading--highlight {
  margin: 0.75em 0 0.25em;
  padding: 0;
  color: var(--forced-contrast-heading-primary, #022851);
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.2;
  color: var(--forced-contrast-heading-primary, #022851);
  font-size: 1.42rem;
  font-style: inherit;
}
:where(:not([class*=block-field-])) > .heading--highlight:first-child {
  margin-top: 0;
}

.heading--auxiliary {
  margin: 0.75em 0 0.25em;
  padding: 0;
  color: var(--forced-contrast-heading-primary, #022851);
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.2;
  color: var(--forced-contrast-heading-secondary, #666);
  font-size: 1.3325rem;
  margin-bottom: 0.5rem;
  color: var(--forced-contrast-heading-primary, #022851);
  font-style: italic;
  font-weight: 700;
}
:where(:not([class*=block-field-])) > .heading--auxiliary:first-child {
  margin-top: 0;
}
@media (min-width: 768px) {
  .heading--auxiliary {
    font-size: 1.7425rem;
  }
}

.heading--weighted {
  margin: 0.75em 0 0.25em;
  padding: 0;
  color: var(--forced-contrast-heading-primary, #022851);
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.2;
  color: var(--forced-contrast-heading-primary, #13639e);
  font-size: 1.6055rem;
  color: var(--forced-contrast-heading-primary, #022851);
  font-weight: 200;
}
:where(:not([class*=block-field-])) > .heading--weighted:first-child {
  margin-top: 0;
}
@media (min-width: 768px) {
  .heading--weighted {
    font-size: 2.0995rem;
  }
}
.heading--weighted--weighted {
  font-weight: 700;
}

.heading--underline {
  margin: 0.75em 0 0.25em;
  padding: 0;
  color: var(--forced-contrast-heading-primary, #022851);
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.2;
  color: var(--forced-contrast-heading-primary, #13639e);
  font-size: 1.6055rem;
  color: var(--forced-contrast-heading-primary, #022851);
  font-weight: 200;
}
:where(:not([class*=block-field-])) > .heading--underline:first-child {
  margin-top: 0;
}
@media (min-width: 768px) {
  .heading--underline {
    font-size: 2.0995rem;
  }
}
.heading--underline:after {
  display: block;
  width: 4rem;
  margin: 0.5rem 0 1rem;
  border-top: 0.42rem dotted #ffbf00;
  content: "";
}
.panel--center .heading--underline:after {
  margin: 0.5rem auto;
}
[class^=category-brand--] .heading--underline:after {
  border-color: #fff;
}

.heading--weighted-underline {
  margin: 0.75em 0 0.25em;
  padding: 0;
  color: var(--forced-contrast-heading-primary, #022851);
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.2;
  color: var(--forced-contrast-heading-primary, #13639e);
  font-size: 1.6055rem;
  color: var(--forced-contrast-heading-primary, #022851);
  font-weight: 200;
  margin: 0.75em 0 0.25em;
  padding: 0;
  color: var(--forced-contrast-heading-primary, #022851);
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.2;
  color: var(--forced-contrast-heading-primary, #13639e);
  font-size: 1.6055rem;
  color: var(--forced-contrast-heading-primary, #022851);
  font-weight: 200;
}
:where(:not([class*=block-field-])) > .heading--weighted-underline:first-child {
  margin-top: 0;
}
@media (min-width: 768px) {
  .heading--weighted-underline {
    font-size: 2.0995rem;
  }
}
.heading--weighted-underline:after {
  display: block;
  width: 4rem;
  margin: 0.5rem 0 1rem;
  border-top: 0.42rem dotted #ffbf00;
  content: "";
}
.panel--center .heading--weighted-underline:after {
  margin: 0.5rem auto;
}
[class^=category-brand--] .heading--weighted-underline:after {
  border-color: #fff;
}
:where(:not([class*=block-field-])) > .heading--weighted-underline:first-child {
  margin-top: 0;
}
@media (min-width: 768px) {
  .heading--weighted-underline {
    font-size: 2.0995rem;
  }
}
.heading--weighted-underline--weighted {
  font-weight: 700;
}

.heading--center-underline {
  margin: 0.75em 0 0.25em;
  padding: 0;
  color: var(--forced-contrast-heading-primary, #022851);
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.2;
  color: var(--forced-contrast-heading-primary, #13639e);
  font-size: 1.6055rem;
  color: var(--forced-contrast-heading-primary, #022851);
  font-weight: 200;
  font-weight: 700;
  text-align: center;
}
:where(:not([class*=block-field-])) > .heading--center-underline:first-child {
  margin-top: 0;
}
@media (min-width: 768px) {
  .heading--center-underline {
    font-size: 2.0995rem;
  }
}
.heading--center-underline:after {
  display: block;
  width: 4rem;
  margin: 0.5rem 0 1rem;
  border-top: 0.42rem dotted #ffbf00;
  content: "";
}
.panel--center .heading--center-underline:after {
  margin: 0.5rem auto;
}
[class^=category-brand--] .heading--center-underline:after {
  border-color: #fff;
}
.heading--center-underline:after {
  margin-inline: auto;
}

.heading--invert {
  margin: 0.75em 0 0.25em;
  padding: 0;
  color: var(--forced-contrast-heading-primary, #022851);
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.2;
  color: var(--forced-contrast-heading-secondary, #666);
  font-size: 1.3325rem;
  color: var(--category-brand-contrast-color, #fff);
}
:where(:not([class*=block-field-])) > .heading--invert:first-child {
  margin-top: 0;
}
@media (min-width: 768px) {
  .heading--invert {
    font-size: 1.7425rem;
  }
}

.heading--invert-box {
  margin: 0.75em 0 0.25em;
  padding: 0;
  color: var(--forced-contrast-heading-primary, #022851);
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.2;
  color: var(--forced-contrast-heading-secondary, #666);
  font-size: 1.3325rem;
  color: var(--category-brand-contrast-color, #fff);
  margin: 0;
  padding: 1rem;
  background-color: var(--category-brand, #022851);
}
:where(:not([class*=block-field-])) > .heading--invert-box:first-child {
  margin-top: 0;
}
@media (min-width: 768px) {
  .heading--invert-box {
    font-size: 1.7425rem;
  }
}
@media (min-width: 992px) {
  .heading--invert-box {
    padding: 1rem;
  }
}

`;